import { render, staticRenderFns } from "./comment-with-reply.vue?vue&type=template&id=0cfc0fe8&"
import script from "./comment-with-reply.vue?vue&type=script&lang=js&"
export * from "./comment-with-reply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports